/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M7.5 19.5C3.3579 19.5 0 16.1421 0 12s3.3579-7.5 7.5-7.5c1.5812 0 3.0482.4893 4.2577 1.3248a7.7277 7.7277 0 0 1 .2357.1697l.0066.005.0066-.005a7.5323 7.5323 0 0 1 .2349-.169C13.4511 4.9894 14.9184 4.5 16.5 4.5c4.1421 0 7.5 3.3579 7.5 7.5s-3.3579 7.5-7.5 7.5c-1.5816 0-3.0488-.4896-4.2585-1.3254a7.0937 7.0937 0 0 1-.2349-.1691L12 18.0005l-.0066.005a7.4485 7.4485 0 0 1-.2356.1696C10.5483 19.0106 9.0813 19.5 7.5 19.5Zm6.9992-1.8417A5.9898 5.9898 0 0 0 16.5 18c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6c-.7016 0-1.375.1204-2.0008.3417a5.9798 5.9798 0 0 0-1.3745.697c.3308.3747.6247.7827.876 1.2184C14.6363 9.3586 15 10.6369 15 12c0 1.3631-.3637 2.6414-.9993 3.7429a7.5176 7.5176 0 0 1-.876 1.2184 5.983 5.983 0 0 0 1.3745.697ZM9.5008 6.3417A5.9903 5.9903 0 0 0 7.5 6c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6c.7016 0 1.375-.1204 2.0008-.3417a5.983 5.983 0 0 0 1.3745-.697 7.5213 7.5213 0 0 1-.876-1.2184C9.3637 14.6414 9 13.3631 9 12c0-1.3631.3637-2.6414.9993-3.7429a7.5176 7.5176 0 0 1 .876-1.2184 5.9801 5.9801 0 0 0-1.3745-.697Zm1.6235 8.3263C10.7247 13.8643 10.5 12.9584 10.5 12c0-.9584.2247-1.8643.6243-2.668A6.0108 6.0108 0 0 1 12 8.0313c.3456.3915.6408.8285.8757 1.3008.3996.8036.6243 1.7095.6243 2.6679 0 .9584-.2247 1.8643-.6243 2.668A6.0099 6.0099 0 0 1 12 15.9687a6.0099 6.0099 0 0 1-.8757-1.3007Z"
    clipRule="evenodd"
  />,
  'GroupBy'
);
